import type { ReactNode, JSX} from "react";
import { cn } from "./cn";

export interface IconBoxProps {
  /** Icon element to display */
  readonly children: ReactNode;
  /** Size variant */
  readonly size?: "xs" | "sm" | "md";
  /** Extra className */
  readonly className?: string;
}

const sizeMap: Readonly<Record<string, string>> = {
  xs: "w-6 h-6 rounded-md",
  sm: "w-5 h-5 rounded-md",
  md: "w-7 h-7 rounded-md",
};

/**
 * A small, rounded container for an icon. Used as leading element in activity rows.
 */
export function IconBox({ children, size = "md", className }: IconBoxProps): JSX.Element {
  return (
    <div
      className={cn(
        "inline-flex items-center justify-center bg-surface-hover text-content-tertiary shrink-0",
        sizeMap[size],
        className,
      )}
    >
      {children}
    </div>
  );
}
